import React, { useEffect } from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/Table';
import TableNA from '../../components/TableNA';
import {
  __,
  dateFrom,
  convertMinutesToHoursAndMinutes,
  setTableParams,
  getURLParam,
} from '../../core/utils';
import * as _ from 'lodash';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { setPlusActions } from '../../redux/actions/general/plus';
import styles from '../../styles/views/timesheets/Timesheets.scss';
import {
  deleteTimesheet,
  deleteUserLeave,
  listTimesheets,
  readTimesheet,
  readUserLeave,
} from '../../redux/actions/table/timesheets';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import Tooltip from '../../components/Tooltip';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import TimeEntriesFlyout from '../../flyouts/timesheets/TimeEntriesFlyout';
import UserLeavesFlyout from '../../flyouts/timesheets/UserLeavesFlyout';
import Avatar from '../../components/Avatar';
import autobind from 'autobind-decorator';
import queryString from 'query-string';
import { redirect } from '../../core/utils';

const mapStateToProps = (state) => {
  return {
    table: state.table['timesheets'],
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.timesheets/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

const OvertimeCell = ({ value, displayValue = String(value) }) => (
  <Tooltip text={__('table.timesheet-overtime-flyout-disabled')}>
    {value ? (
      displayValue
    ) : (
      <span>
        <TableNA />
      </span>
    )}
  </Tooltip>
);

@connect(mapStateToProps, mapDispatchToProps)
class Timesheets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team_roles: [],
    };
  }

  componentDidMount() {
    // enableProjectsDropdown(({ stage_id }) =>
    //   redirect('/stages/' + stage_id + '/tasks')
    // );
    // enableStagesDropdown(({ stage_id }) =>
    //   redirect('/stages/' + stage_id + '/tasks')
    // );

    createSidebar({
      title: __('submenu.title.time-log-main'),
      items: [
        {
          title: __('submenu.title.time-log-submodule'),
          link: () => '/timesheets',
          active: true,
        },
        {
          title: __('submenu.title.all-timesheet-reports'),
          link: () => '/timesheet_report',
        },
        {
          title: __('Timesheet Entries'),
          link: () => '/timesheet_entries',
        },
      ],
    });

    let params = {
      sort_by: 'date',
      order: 'desc',
    };

    this._setURLParams({
      ...params,
    });

    setPlusActions([
      {
        title: __('button.create-new-timesheet'),
        onClick: () =>
          this.props.actions.setTableParams({
            wizard_timesheet_add: true,
          }),
      },
    ]);
  }

  @autobind
  _setURLParams(params) {
    const search = queryString.stringify({
      ...queryString.parse(this.props.history.location.search),
      ...params,
    });
    redirect({ search }, true);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        setTableParams('timesheets', {
          flyout: undefined,
        });
      }

      this.props.table.is_user_leave
        ? readUserLeave(this.props.table.clicked_row)
        : readTimesheet(this.props.table.clicked_row);
    }
  }

  _handleOpacity(value, row) {
    return !row.deactivated ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  render() {
    const columns = [
      {
        key: 'user_name',
        name: __('table.columns.timesheet-user'),
        width: 110,
        required: true,
        //value: (value) => <Tooltip text={value}>{value}</Tooltip>,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : (
            <Tooltip text={value}>{value}</Tooltip>
          ),
      },
      {
        key: 'project_code',
        name: __('table.columns.timesheet-project_code'),
        width: 65,
        default: true,
        // value: (value, row) =>
        //   value ? (
        //     <Tooltip text={row?.project_name}>{String(value)}</Tooltip>
        //   ) : (
        //     <TableNA />
        //   ),
        value: (value, row) => {
          return row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={row?.project_name}>{String(value)}</Tooltip>
          ) : (
            <TableNA />
          );
        },
      },
      {
        key: 'project_name',
        name: __('table.columns.timesheet-project_name'),
        width: 130,
        default: true,
        value: (value, row) => {
          console.log(value, 'VALUEEE PROJECT NAME');
          return row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={row?.project_name}>{String(value)}</Tooltip>
          ) : (
            <TableNA />
          );
        },
      },

      {
        key: 'stage_order',
        name: __('table.columns.timesheet-stage-order'),
        width: 50,
        default: true,
        // value: (value, row) =>
        //   value ? (
        //     <Tooltip text={row?.stage_name}>{String(value)}</Tooltip>
        //   ) : (
        //     <TableNA />
        //   ),
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={row?.stage_name}>{String(value)}</Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'stage_name',
        name: __('table.columns.timesheet-stage-name'),
        width: 130,
        default: true,
        // value: (value, row) =>
        //   value ? (
        //     <Tooltip text={row?.stage_name}>{String(value)}</Tooltip>
        //   ) : (
        //     <TableNA />
        //   ),
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={row?.stage_name}>{String(value)}</Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'substage_order',
        name: __('table.columns.timesheet-substage-order'),
        width: 50,
        default: true,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={row?.substage_name}>{String(value)}</Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'substage_name',
        name: __('table.columns.timesheet-substage-name'),
        width: 130,
        default: true,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={row?.substage_name}>{String(value)}</Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'task_title',
        name: __('table.columns.timesheet-task'),
        width: 130,
        default: true,
        // value: (x, row) =>
        //   x ? (
        //     <Tooltip
        //       text={`T-${row.task_identifier}: ${row.task_title}`}
        //     >{`T-${row.task_identifier}: ${row.task_title}`}</Tooltip>
        //   ) : (
        //     <TableNA />
        //   ),
        value: (x, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell
              value={x}
              displayValue={`T-${row.task_identifier}: ${row.task_title}`}
            />
          ) : x ? (
            <Tooltip text={`T-${row.task_identifier}: ${row.task_title}`}>
              {`T-${row.task_identifier}: ${row.task_title}`}
            </Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'minutes',
        name: __('table.columns.timesheet-duration'),
        width: 90,
        // value: (value) => {
        //   return convertMinutesToHoursAndMinutes(value, true);
        // },
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell
              value={value}
              displayValue={convertMinutesToHoursAndMinutes(value, true)}
            />
          ) : value ? (
            <Tooltip text={convertMinutesToHoursAndMinutes(value, true)}>
              {convertMinutesToHoursAndMinutes(value, true)}
            </Tooltip>
          ) : (
            <TableNA />
          ),
        required: true,
      },
      {
        key: 'leave_reason_name',
        name: __('table.columns.timesheet-leave-reason'),
        width: 130,
        // value: (value) => <Tooltip text={value}>{value}</Tooltip>,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={value}>{value}</Tooltip>
          ) : (
            <TableNA />
          ),
        active: false,
      },
      {
        key: 'status',
        name: __('table.columns.timesheet-status'),
        width: 80,
        // value: (value) => <Tooltip text={value}>{value}</Tooltip>,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={value}>{value}</Tooltip>
          ) : (
            <TableNA />
          ),
        active: false,
      },
      {
        key: 'date',
        name: __('table.columns.timesheet-date'),
        width: 75,
        required: true,
        // value: (value) => (
        //   <Tooltip text={dateFrom(value)}>{dateFrom(value)}</Tooltip>
        // ),
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} displayValue={dateFrom(value)} />
          ) : value ? (
            <Tooltip text={dateFrom(value)}>{dateFrom(value)}</Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'description',
        name: __('table.columns.timesheet-description'),
        default: true,
        // value: (value) =>
        //   value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={value}>{value}</Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'created_at',
        name: __('table.columns.timesheet-created-at'),
        width: 75,
        // value: (value) => (
        //   <Tooltip text={dateFrom(value)}>{dateFrom(value)}</Tooltip>
        // ),
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} displayValue={dateFrom(value)} />
          ) : value ? (
            <Tooltip text={dateFrom(value)}>{dateFrom(value)}</Tooltip>
          ) : (
            <TableNA />
          ),
        default: true,
      },
      {
        key: 'updated_at',
        name: __('table.columns.timesheet-updated-at'),
        width: 75,
        // value: (value) => (
        //   <Tooltip text={dateFrom(value)}>{dateFrom(value)}</Tooltip>
        // ),
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} displayValue={dateFrom(value)} />
          ) : value ? (
            <Tooltip text={dateFrom(value)}>{dateFrom(value)}</Tooltip>
          ) : (
            <TableNA />
          ),
        default: true,
      },
      {
        key: 'address_book_company_name',
        name: __('table.columns.timesheet-work-site'),
        width: 110,
        // value: (value) =>
        //   value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <Tooltip text={value}>{value}</Tooltip>
          ) : (
            <TableNA />
          ),
        default: true,
      },
      {
        key: 'is_billable',
        name: __('table.columns.timesheet-is-billable'),
        width: 50,
        // value: (value) => <input type='checkbox' checked={value} />,
        value: (value, row) =>
          row.object_type === 'overtime' ? (
            <OvertimeCell value={value} />
          ) : value ? (
            <input type='checkbox' checked={value} />
          ) : (
            <TableNA />
          ),
        default: true,
      },
      {
        key: 'approved_by',
        name: __('table.columns.timesheet-approved_by'),
        width: 50,
        value: (approver) => (
          <div key={approver?.id}>
            {_.size(approver) == 0 && <TableNA />}
            {_.size(approver) == 1 && (
              <Avatar
                {..._.first(approver)}
                avatar_url={_.first(approver)?.avatar_url}
                name={_.first(approver)?.fullname}
                tooltip={true}
              />
            )}
            {_.size(approver) > 1 && (
              <Tooltip text={_.map(approver, 'fullname').join('\n')}>
                <div className={styles.more}>
                  <span>{_.size(approver)}</span>
                </div>
              </Tooltip>
            )}
          </div>
        ),
        active: false,
      },
      {
        key: 'rejected_by',
        name: __('table.columns.timesheet-rejected-by'),
        width: 50,
        value: (rejector) => (
          <div>
            {_.size(rejector) == 0 && <TableNA />}
            {_.size(rejector) == 1 && (
              <Avatar
                {..._.first(rejector)}
                avatar_url={_.first(rejector)?.avatar_url}
                name={_.first(rejector)?.fullname}
                tooltip={true}
              />
            )}
            {_.size(rejector) > 1 && (
              <Tooltip text={_.map(rejector, 'fullname').join('\n')}>
                <div className={styles.more}>
                  <span>{_.size(rejector)}</span>
                </div>
              </Tooltip>
            )}
          </div>
        ),
        active: false,
      },
    ];

    // object_types are leave, timeheet and overtime which wont open flyouts

    const singleActions = (timesheet_id) => {
      let actions = [];
      const row = _.find(
        this.props.table.data,
        (row) => row.id == timesheet_id,
      );
      const object_type = row.object_type == 'leave';

      actions.push([
        <Tooltip
          text={__('table.timesheets.actions.delete.tooltip')}
          key={_.uniqueId()}
        >
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();

              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: __(
                  'table.timesheets.actions.delete.tooltip.this-process-cannot-undone',
                ),
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-delete'),
                    onClick: () => {
                      const action = object_type
                        ? deleteUserLeave(row.leave_uuid)
                        : deleteTimesheet(timesheet_id);
                      action.then(() => {
                        hideAlertbox();

                        setNotification(
                          __(
                            'table.timesheets.actions.delete.selected-timesheet-deleted',
                          ),
                        );
                        listTimesheets();

                        this.props.actions.setTableParams({
                          selected_rows: undefined,
                        });
                      });
                    },
                  },
                ],
              });
            }}
          />
        </Tooltip>,
      ]);

      return actions;
    };

    const previewTimeEntry = (
      <TimeEntriesFlyout
        data={this.props.table.flyout}
        readAction={(timesheet_id) => {
          return new Promise(() => {
            readTimesheet(getURLParam('id') || timesheet_id);
          });
        }}
      />
    );

    const previewUserLeave = (
      <UserLeavesFlyout
        data={this.props.table.flyout}
        readAction={() => {
          return new Promise(() => {
            readUserLeave(getURLParam('leave_uuid'));
          });
        }}
      />
    );

    return (
      <Table
        listAction={listTimesheets}
        onRowClick={(id, row) => {
          if (row.object_type === 'overtime') return;

          this.props.actions.setTableParams({
            clicked_row:
              this.props.table.clicked_row != id
                ? row.object_type == 'leave'
                  ? row.leave_uuid
                  : row.id
                : undefined,
            is_user_leave: row.object_type == 'leave',
          });
        }}
        name='timesheets'
        title={__('submenu.title.time-log-submodule')}
        columns={columns}
        singleActions={singleActions}
        //groupActions={groupActions}
        //gridOptions={gridOptions}
        // preview={this.props.table.flyout ? previewTimeEntry : []}
        preview={
          this.props.table.is_user_leave && this.props.table.flyout
            ? previewUserLeave
            : previewTimeEntry
        }
        onLoad={() => listActiveModules()}
        rowClassName={(row) =>
          row.object_type === 'overtime' && styles.overtimeRow
        }
      />
    );
  }
}

export default Timesheets;
